import React from "react";
import "./Button.css";

export default function Button({
  className = "",
  loading = false,
  disabled = false,
  children,
  ...props
}) {
  return (
    <button
      className={className}
      disabled={disabled || loading}
      {...props}
    >
      {loading ? (
        <span className="btn-loading">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
        </span>
      ) : (
        children
      )}
    </button>
  );
}
